import { render, staticRenderFns } from "./fourGrids.vue?vue&type=template&id=a87bab68&scoped=true&"
import script from "./fourGrids.vue?vue&type=script&lang=js&"
export * from "./fourGrids.vue?vue&type=script&lang=js&"
import style0 from "./fourGrids.vue?vue&type=style&index=0&id=a87bab68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87bab68",
  null
  
)

export default component.exports